export default "__VITE_ASSET__42260d1a__"